import { render, staticRenderFns } from "./OperatnGlobeIcon.vue?vue&type=template&id=749956fe&"
import script from "./OperatnGlobeIcon.vue?vue&type=script&lang=ts&"
export * from "./OperatnGlobeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports